import xhr from "./xhr/axios";
/**
 * 用户相关的 API
 */
class SystemService {
  /**
   * 公司介绍详情
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  gsjs() {
    return xhr({
      method: "get",
      url: "/about/views/api_about_gsjs_detail/"
    });
  }

  /**
   * 发展历程列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  fzlc() {
    return xhr({
      method: "get",
      url: "/about/views/api_about_fzlc_list/"
    });
  }

  /**
   * 合作品牌列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  hzpp() {
    return xhr({
      method: "get",
      url: "/about/views/api_about_hzppfl_list/"
    });
  }

  /**
   * 核心业务-类别列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  busyFl(params) {
    return xhr({
      method: "get",
      url: "/business/views/api_business_fl_list/",
      params
    });
  }

  /**
   * 核心业务-类别内容列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  busyList(params) {
    return xhr({
      method: "get",
      url: "/business/views/api_business_list/",
      params
    });
  }

  /**
   * 站点信息
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  infoDetail(params) {
    return xhr({
      method: "get",
      url: "/common/views/api_common_info_detail/",
      params
    });
  }

  /**
   * 新闻类别列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  newsFlList(params) {
    return xhr({
      method: "get",
      url: "/news/views/api_news_fl_list/",
      params
    });
  }

  /**
   * 新闻内容列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  newsList(params) {
    return xhr({
      method: "get",
      url: "/news/views/api_news_list/",
      params
    });
  }

  /**
   * 新闻内容列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  newsDetail(params) {
    return xhr({
      method: "get",
      url: "/news/views/api_news_detail/",
      params
    });
  }

  /**
   * 加入我们类别列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  joinFlList(params) {
    return xhr({
      method: "get",
      url: "/join/views/api_join_fl_list/",
      params
    });
  }

  /**
   * 加入我们列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  joinList(params) {
    return xhr({
      method: "get",
      url: "/join/views/api_join_list/",
      params
    });
  }

  /**
   * 企业文化类别列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  cultureFlList(params) {
    return xhr({
      method: "get",
      url: "/culture/views/api_culture_fl_list/",
      params
    });
  }

  /**
   * 企业文化列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  cultureList(params) {
    return xhr({
      method: "get",
      url: "/culture/views/api_culture_list/",
      params
    });
  }

  /**
   * 企业文化详情
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  cultureDetail(params) {
    return xhr({
      method: "get",
      url: "/culture/views/api_culture_detail/",
      params
    });
  }

  /**
   * 流量统计
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  postTracking(params) {
    return xhr({
      method: "post",
      url: "/tracking/views/api_tracking_post/",
      params
    });
  }

  /**
   * 物流轨迹
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  logistics(params) {
    return xhr({
      method: "post",
      url: "/logistics/views/api_logistics_query/",
      params
    });
  }

  /**
   * 仓库列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  warehouse(params) {
    return xhr({
      method: "post",
      url: "/common/views/api_warehouse_list/",
      params
    });
  }

  /**
   * 航运轨迹
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  logisticsShip(params) {
    return xhr({
      method: "post",
      url: "/logistics/views/api_logistics_query_v2/",
      params
    });
  }

  /**
   * 获取船列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  shipListDetail(params) {
    return xhr({
      method: "get",
      url:'/logistics/views/api_logistics_ship_gis/',
      params
    });
  }

  /**
   * 获取货车列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  carListDetail(params) {
    return xhr({
      method: "get",
      url: "/logistics/views/api_logistics_truck_gis/",
      params
    });
  }
 /**
   * 获取实时地理位置
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  getLocation = param => {
    return xhr({
      method: "post",
      url: "logistics/views/api_logistics_realtime_data/",
      params: param
    });
  };

  /**
   * 获取视频地址
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
   getLiveUrl = (param) => {
    return xhr({
      method: 'post',
      url: '/warehouse/views/api_warehouse_video_url/',
      params: param,
    })
  }

  /**
   * 登录接口
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  loginIn = param => {
    return xhr({
      method: "post",
      url: "/user/views/api_user_login/",
      params: param
    });
  };
/**
   * 忘记密码
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
 forgetPsw = param => {
  return xhr({
    method: "post",
    url: "/user/views/api_user_forget_psw/",
    params: param
  });
};
 /**
   * 发送短信
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
  sendPhone = param => {
    return xhr({
      method: "post",
      url: "/user/views/api_user_sms_send/",
      params: param
    });
  }; 

   /**
   * 校验验证码
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
    vertifyCode = param => {
      return xhr({
        method: "post",
        url: "/user/views/api_user_sms_confirm/",
        params: param
      });
    };

   /**
   * 创建预定订单-货车
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
    creatReserve = param => {
      return xhr({
        method: "post",
        url: "/common/views/api_reserve_truck_create/",
        params: param
      });
    };

    /**
   * 创建预定订单-船舶
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
     creatReserveShip = param => {
      return xhr({
        method: "post",
        url: "/common/views/api_reserve_ship_create/",
        params: param
      });
    };

  /**
   * 取消订单
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
        cancelOrder = param => {
          return xhr({
            method: "post",
            url: "/common/views/api_reserve_cancel/",
            params: param
          });
        };

     /**
   * 删除订单
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
      deletOrder = param => {
        return xhr({
          method: "post",
          url: "/common/views/api_reserve_delete/",
          params: param
        });
      };

    /**
   * 预定列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
     reserveList = param => {
      return xhr({
        method: "get",
        url: "/common/views/api_reserve_list/",
        params: param
      });
    };

     /**
   * 车主-待接列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
      carOrder = param => {
        return xhr({
          method: "get",
          url: "/common/views/api_reserve_driver_1_list/",
          params: param
        });
      };


       /**
   * 车主-我的列表
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
     driverOrder = param => {
      return xhr({
        method: "get",
        url: "/common/views/api_reserve_driver_23_list/",
        params: param
      });
    };

  /**
   * 车主-订单操作
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
    opeateOrder = param => {
      return xhr({
        method: "post",
        url: "/common/views/api_reserve_driver_operate/",
        params: param
      });
    };

  /**
   * 车主-接单操作
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
   driverGetOrder = param => {
    return xhr({
      method: "post",
      url: "common/views/api_reserve_driver_order/",
      params: param
    });
  };



   /**
   * 用户信息
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
    getUserInfo = param => {
      return xhr({
        method: "get",
        url: "/user/views/api_user_info/",
        params: param
      });
    };

    /**
   * 退出登录
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
       loginOut = param => {
        return xhr({
          method: "get",
          url: "/user/views/api_user_logout/",
          params: param
        });
      };

      /**
   * 通用接口
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
       modelList = param => {
        return xhr({
          method: "post",
          url: "/youhao_website/views/v_model_list_detail/",
          params: param
        });
      };

     /**
   * 物流公司加入-第一步加入
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
      stepOne = param => {
        return xhr({
          method: "post",
          url: "/common/views/api_driver_join_step_one/",
          params: param
        });
      };

     /**
   * 物流公司加入-第二步个人信息
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
      stepTwo = param => {
        return xhr({
          method: "post",
          url: "/common/views/api_driver_join_step_two/",
          params: param
        });
      };

     /**
   * 物流公司加入-第三步车辆信息
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
      stepThree = param => {
        return xhr({
          method: "post",
          url: "/common/views/api_driver_join_step_three/",
          params: param
        });
      };

     /**
   * 物流公司加入-第四步照片信息
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
      stepFour = param => {
        return xhr({
          method: "post",
          url: "/common/views/api_driver_join_step_four/",
          params: param
        });
      };

           /**
   * 订单詳情
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
      orderDetail = param => {
        return xhr({
          method: "get",
          url: "/common/views/api_reserve_order_detail/",
          params: param
        });
      };

      
    /**
   * 查询城市
   * @param {any} params
   * @returns
   * @memberof SystemService
   */
    cityQuery = param => {
      return xhr({
        method: "get",
        url: "/common/views/api_common_city_query/",
        params: param
      });
    };
}

// 实例化后导出，全局单例
export default new SystemService();



// WEBPACK FOOTER //
// ./src/services/systemService.js